import { createAction } from 'redux-actions';
import Types from './types';

export const getErrorsRequest = createAction(Types.GET_ERRORS_REQUEST);
export const getErrorsFulfilled = createAction(Types.GET_ERRORS_FULFILLED);
export const getErrorsRejected = createAction(Types.GET_ERRORS_REJECTED);

export const clearFieldsErrors = createAction(Types.CLEAR_FIELDS_REQUEST);
export const clearFieldsErrorsFulfilled = createAction(
  Types.CLEAR_FIELDS_FULFILLED
);
